import { ap, assoc, call, curry, identity, keys, of, map, path, reduce, split, unapply, useWith } from 'ramda'
/**
 * Derivative function by property path in dot-notation for deep fields
 *
 * @func
 * @param {Array} list of property path(s) by dot-notation ('a.b.c') in string
 * @param {Object} object to be accessed
 * @example
 *      const obj = {
 *        a: { b: { c: 1 } },
 *        x: 2
 *      };
 *      propsDotPath(['a.b.c', 'x'], obj);
 *      // => [ 1, 2 ]
 * @reference https://github.com/ramda/ramda/wiki/Cookbook#derivative-of-rprops-for-deep-fields
 */
const dotPath = useWith(path, [split('.')]) // eslint-disable-line react-hooks/rules-of-hooks

export const propsDotPath = useWith(ap, [map(dotPath), of]) // eslint-disable-line react-hooks/rules-of-hooks
export const deepGet = useWith(path, [split('.'), identity]) // eslint-disable-line react-hooks/rules-of-hooks
export const callAll = (...funcs) => unapply(call(ap(funcs)))
export const renameProp = curry(
  (oldProp, newProp, { [oldProp]: oldValue, ...others }) => ({ ...others, [newProp]: oldValue })
)
export const renameKeys = curry((keysMap, obj) =>
  reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj))
)
